module.exports = __webpack_public_path__ + "448c34a56d699c29117adc64c43affeb.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.3.7@bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
 ** module id = 179
 ** module chunks = 0
 **/